import script from "./cabinet.vue?vue&type=script&setup=true&lang=js"
export * from "./cabinet.vue?vue&type=script&setup=true&lang=js"

import "./cabinet.vue?vue&type=style&index=0&id=4faa3eb1&lang=sass"

const __exports__ = script;

export default __exports__